'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Tingle Context
 * The environment for tingle's initialization
 * @author gnosaij
 *
 * Copyright 2014-2015, Tingle Team, Alinw.
 * All rights reserved.
 */
var win = window;
var doc = document;
// 引入环境检测模块
var env = require('./env');
var classnames = require('classnames');

// 全局点击态初始化
require("./touchEffect").attach(doc.body);

/**
 * 变换两个参数的函数到多个参数
 * @param  {Function} fn 基函数
 * @return {Function} 变换后的函数
 * @demo
 *      let add = (x, y) => { return x+y; }
 *      add = redo(add);
 *      add(1,2,3) => 6
 */
var redo = function redo(fn) {
    return function () {
        var args = arguments;
        var ret = fn(args[0], args[1]);
        for (var i = 2, l = args.length; i < l; i++) {
            ret = fn(ret, args[i]);
        }
        return ret;
    };
};

/**
 * 对象扩展
 * @param  {Object} receiver
 * @param  {Object} supplier
 * @return {Object} 扩展后的receiver对象
 */
var mixin = redo(function (receiver, supplier) {
    if (Object.keys) {
        Object.keys(supplier).forEach(function (property) {
            Object.defineProperty(receiver, property, Object.getOwnPropertyDescriptor(supplier, property));
        });
    } else {
        for (var property in supplier) {
            if (supplier.hasOwnProperty(property)) {
                receiver[property] = supplier[property];
            }
        }
    }
    return receiver;
});

/**
 * 获取自增长id
 * @return {Number}
 */
var tid = 0;
var getTID = function getTID() {
    return tid++;
};

/**
 * rem system
 * @TODO 这个闭包 + rem方法 + makePrivateRem方法的整合
 */
(function (docEl, fontEl) {
    var dpr = win.devicePixelRatio || 1;

    // 类似小米2 webView webkit版本是534及以下，避免闪屏
    var matches = navigator.userAgent.match(/Android[\S\s]+AppleWebkit\/?(\d{3})/i);
    if (matches && matches[1] <= 534) {
        dpr = 1;
    }

    win.dpr = dpr;

    if (!docEl.getAttribute('data-dpr')) {
        // 在body上添加环境检测的标识类className
        doc.documentElement.className = classnames(doc.documentElement.className.trim(), _defineProperty({
            pc: env.isPC,
            mobile: env.isMobile,
            hairline: env.supportHairline
        }, 'dpr' + dpr, dpr > 1));

        docEl.setAttribute('data-dpr', dpr);
        docEl.firstElementChild.appendChild(fontEl);
    }

    var setRem = function setRem() {
        var docWidth = docEl.clientWidth;
        win.rem = docWidth / 10;

        // ZTE 中兴 ZTE U930_TD/1.0 Linux/2.6.39/Android/4.0Release/3.5.2012 Browser/AppleWebkit534.30
        // 老机器bug rem计算不是标准=html fontsize
        if (/ZTE U930_TD/.test(navigator.userAgent)) {
            win.rem = win.rem * 1.13;
        }

        fontEl.innerHTML = 'html{font-size:' + win.rem + 'px!important}';
    };

    win.addEventListener('resize', function () {
        // resize时立刻change,pad上刷屏明显
        setRem();
    }, false);
    win.addEventListener('pageshow', function (e) {
        if (e.persisted) {
            setRem();
        }
    }, false);

    setRem();
})(doc.documentElement, doc.createElement('style'));

var defaultArtBoardWidth = 750;

var rem = function rem(px, artBoardWidth) {
    return px * 10 / (artBoardWidth || defaultArtBoardWidth) + 'rem';
};

var makePrivateRem = function makePrivateRem(artBoardWidth) {
    return function (px) {
        return rem(px, artBoardWidth);
    };
};

// 全局默认配置
var defaultGlobalConfig = {
    svgPath: ''
};

var runtimeGlobalConfig = {};

/**
 * Top namespace
 */
// TODO setGlobal/getGlobal
var Context = {
    getTID: getTID,
    mixin: mixin,
    noop: function noop(v) {
        return v;
    },

    rem: rem,
    makePrivateRem: makePrivateRem,
    /**
     * 执行全局配置
     * @param options
     */
    setGlobal: function setGlobal(options) {
        runtimeGlobalConfig = mixin({}, defaultGlobalConfig, options);
    },

    /**
     * 获取全局配置
     * @param property {String} optional
     * @returns {*}
     */
    getGlobal: function getGlobal(property) {
        return property ? runtimeGlobalConfig[property] : runtimeGlobalConfig;
    },

    /**
     * 为 class 添加前缀
     * @param property {String} required
     * @returns {*}
     */
    prefixClass: function prefixClass(classNames) {
        var prefix = Context.getGlobal('classNamePrefix') || 't';
        return classNames.split(' ').map(function (className) {
            return prefix + '-' + className;
        }).join(' ');
    }
};

mixin(Context, env);

// 多次require时保证返回同一个全局对象 保证setGlobal/getGlobal正确执行
module.exports = win.__TingleContext || (win.__TingleContext = Context);
//# sourceMappingURL=data:application/json;base64,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



/*****************
 ** WEBPACK FOOTER
 ** ./~/@ali/tingle-context/dist/Context.js
 ** module id = 2
 ** module chunks = 0
 **/